<template>
  <div class="custom-container">
    <v-layout justify-space-between>
      <v-flex shrink>
        <v-layout align-center>
          <svg
            height="30"
            viewBox="0 0 50 50">
            <path
              :d="sitePath"
              fill="#8d6e63"
              stroke="black"/>
          </svg>
          <span
            class="ml-3"
            style="color: black;">
            {{ $route.params.id }}
          </span>
        </v-layout>
      </v-flex>
      <v-flex shrink>
        <v-layout align-center>
          <svg
            height="30"
            viewBox="0 0 50 50">
            <path
              :d="sitePath"
              fill="#e53935"
              stroke="black"/>
          </svg>
          <svg
            height="30"
            viewBox="0 0 50 50">
            <path
              :d="sitePath"
              fill="#4caf50"
              stroke="black"/>
          </svg>
          <span
            class="ml-3"
            style="color: black;">
            10 nearest sites
          </span>
        </v-layout>
      </v-flex>
      <v-flex shrink>
        <v-layout align-center>
          <svg
            width="30"
            viewBox="0 0 50 50">
            <path
              :d="storePath"
              fill="#90caf9"
              stroke="black"/>
          </svg>
          <span
            class="ml-3"
            style="color: black;">
            Franchises
          </span>
        </v-layout>
      </v-flex>
    </v-layout>
  </div>
</template>

<script>
import { SITE, HARDWARE_STORE } from "./icons.js";

export default {
  name: "map-legend",
  computed: {
    sitePath () {
      return SITE;
    },
    storePath () {
      return HARDWARE_STORE;
    }
  }
};
</script>

<style scoped>
.custom-container {
  background-color: #fff;
  border: none;
  border-top: 1px solid grey;
  padding: 5px;
}
</style>



// WEBPACK FOOTER //
// src/components/Site/Map/Legend.vue